// extracted by mini-css-extract-plugin
module.exports = {"section":"D_section__Zh8_W"};